import { Extension } from '@tiptap/core'
import Suggestion from '@tiptap/suggestion'

// Simple renderer without external libs
function renderSuggestionList() {
  let popup = null

  const createPopup = props => {
    const { clientRect } = props
    const container = document.createElement('div')
    container.className =
      'bg-white border border-gray-200 rounded shadow-md text-sm text-gray-700 max-h-60 overflow-y-auto'
    container.style.position = 'absolute'
    container.style.zIndex = '1000'
    positionPopup(container, clientRect)
    document.body.appendChild(container)
    return container
  }

  const positionPopup = (container, clientRect) => {
    if (!clientRect) return
    const { top, left, height } = clientRect()
    container.style.top = `${top + height + window.scrollY}px`
    container.style.left = `${left + window.scrollX}px`
  }

  const onStart = props => {
    popup = createPopup(props)
    updateList(props)
  }

  const onUpdate = props => {
    updateList(props)
    positionPopup(popup, props.clientRect)
  }

  const onKeyDown = props => {
    if (props.event.key === 'Escape') {
      onExit()
      return true
    }
    const items = Array.from(popup.querySelectorAll('button'))
    let currentIndex = items.findIndex(i => i.classList.contains('bg-gray-100'))
    if (props.event.key === 'ArrowDown') {
      currentIndex = (currentIndex + 1) % items.length
      highlight(items, currentIndex)
      return true
    }
    if (props.event.key === 'ArrowUp') {
      currentIndex = (currentIndex - 1 + items.length) % items.length
      highlight(items, currentIndex)
      return true
    }
    if (props.event.key === 'Enter') {
      if (currentIndex >= 0) {
        items[currentIndex].click()
        return true
      }
    }
    return false
  }

  const onExit = () => {
    if (popup) {
      popup.remove()
      popup = null
    }
  }

  function updateList(props) {
    const { items, command } = props
    popup.innerHTML = ''
    items.forEach((item, index) => {
      const btn = document.createElement('button')
      btn.type = 'button'
      const clean = item.label
        .replace(/^\s*\{\{\s*/, '')
        .replace(/\s*\}\}\s*$/, '')
      btn.innerHTML = `<span class="text-indigo-500">{{</span><span class="mx-1">${clean}</span><span class="text-indigo-500">}}</span>`
      btn.className =
        'flex items-center gap-0 w-full px-3 py-1 text-left hover:bg-indigo-50 hover:text-indigo-600'
      if (index === 0) btn.classList.add('bg-gray-100')
      btn.addEventListener('click', () => command(item))
      popup.appendChild(btn)
    })
  }

  function highlight(items, index) {
    items.forEach(i => i.classList.remove('bg-gray-100'))
    items[index].classList.add('bg-gray-100')
    items[index].scrollIntoView({ block: 'nearest' })
  }

  return { onStart, onUpdate, onKeyDown, onExit }
}

const VariableSuggestion = Extension.create({
  name: 'variableSuggestion',
  addOptions() {
    return {
      variables: [],
      char: '{',
    }
  },
  addProseMirrorPlugins() {
    return [
      Suggestion({
        char: this.options.char,
        startOfLine: false,
        allowSpaces: false,
        editor: this.editor,
        items: ({ query }) => {
          return this.options.variables
            .filter(v => v.toLowerCase().includes(query.toLowerCase()))
            .slice(0, 20)
            .map(v => ({ label: v }))
        },
        command: ({ editor, range, props }) => {
          let content = props.label.trim()
          if (!content.startsWith('{{')) {
            content = `{{ ${content} }}`
          }
          editor.chain().focus().insertContentAt(range, content).run()
        },
        render: renderSuggestionList,
      }),
    ]
  },
})

export default VariableSuggestion
